const moduleSelectedDateSchedule = {
    namespaced: true,
    state: {
        daySelected: {},
    },
    getters: {
        getSelectedDateSchedule(state) {
            return state.daySelected;
        },
    },
    mutations: {
        setSelectedDateSchedule(state, daySelected) {
            state.daySelected = daySelected;
        },
    },
};
export default moduleSelectedDateSchedule;
